import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import IntroAnimation from './Components/IntroAnimation/IntroAnimation';
import Header from './Components/Header/Header';
import AboutMe from './Components/AboutMe/AboutMe';
import ProjectTable from './Components/Projects/Projects';
import Experience from './Components/Experience/Experience';
import Education from './Components/Education/Education';
import ProjectPage from './Components/Projects/ProjectPage';
import Misc from './Components/Misc/Misc';
import './App.css';

const SECTION_IDS = ['about', 'experience', 'education', 'projects', 'misc'];

const AppInner = () => {
  const location = useLocation();
  const isProjectPage = location.pathname.startsWith('/projects/');

  const [scrollY, setScrollY] = useState(() => window.scrollY);
  const [dark, setDark] = useState(() => localStorage.getItem('theme') !== 'light');
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const sy = window.scrollY;
      setScrollY(sy);

      const mid = sy + window.innerHeight * 0.4;
      let active = '';
      for (const id of SECTION_IDS) {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= mid) active = id;
      }
      setActiveSection(active);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('dark', dark);
    localStorage.setItem('theme', dark ? 'dark' : 'light');
  }, [dark]);

  const animProgress = Math.min(scrollY / (window.innerHeight * 0.5), 1);
  const scrolled = isProjectPage || animProgress >= 0.95;

  return (
    <>
      <Header
        scrolled={scrolled}
        dark={dark}
        activeSection={activeSection}
        onToggleTheme={() => setDark(d => !d)}
      />
      <Routes>
        <Route path="/projects/:projectId" element={<ProjectPage />} />
        <Route path="*" element={
          <div className="App">
            <IntroAnimation scrollY={scrollY} />
            <section id="about" className="page-section">
              <AboutMe />
            </section>
            <section id="experience" className="page-section">
              <Experience />
            </section>
            <section id="education" className="page-section">
              <Education />
            </section>
            <section id="projects" className="page-section">
              <ProjectTable />
            </section>
            {/* misc section — hidden until ready */}
            {false && <section id="misc" className="page-section"><Misc /></section>}
          </div>
        } />
      </Routes>
    </>
  );
};

const App = () => (
  <Router>
    <AppInner />
  </Router>
);

export default App;
